import { render, staticRenderFns } from "./EmbedGrantChart2.vue?vue&type=template&id=5cedbbd5"
import script from "./EmbedGrantChart2.vue?vue&type=script&lang=js"
export * from "./EmbedGrantChart2.vue?vue&type=script&lang=js"
import style0 from "./EmbedGrantChart2.vue?vue&type=style&index=0&id=5cedbbd5&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports